import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslocoService} from '@ngneat/transloco';
import {debounceTime, Subject, switchMap} from 'rxjs';
import {RACE_DETAILS} from 'src/app/app-routing.module';
import {environment} from "@environment";
import {AbstractComponent} from "../../abstract.component";
import {ActionResultList, FindRacesRequest, Race} from "@model";
import {RaceService} from "@services";

@Component({
  selector: 'app-search-bar-races',
  templateUrl: './search-bar-races.component.html',
  styleUrls: ['./search-bar-races.component.scss']
})
export class SearchBarRacesComponent extends AbstractComponent {
  races: Race[] = [];
  inputValue: string = "";
  searchQuery = new Subject();
  showEmptyState: boolean = false;
  isLoading: boolean = false;

  constructor(private raceService: RaceService, public translocoService: TranslocoService, private router: Router,
              private route: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {

    this.subscribeToSearchResult();

    this.subscriptions.push(this.route.queryParams.subscribe(_ => {
      this.races = [];
      this.inputValue = "";
      this.showEmptyState = false;
    }));
  }

  subscribeToSearchResult(): void {
    this.subscriptions.push(this.searchQuery.pipe(
      debounceTime(environment.fullTextSearchDelay), switchMap((searchValue) => {
        return this.raceService.searchRaces(FindRacesRequest.createRacesFilterRequest({name: <string>searchValue}));
      })).subscribe((value: ActionResultList<Race[], number>) => {
      if (value != null && value.result != null && value.result.length > 0 && this.inputValue.length !== 0) {
        this.races = value.result;
        this.showEmptyState = false;
      } else {
        this.races = [];
        if (this.inputValue.length > 0) {
          this.showEmptyState = true;
        }
      }
      this.isLoading = false;
    }));
  }

  public onSearchQueryInput(value: string): void {
    this.inputValue = value;
    if (this.inputValue.length > 1) {
      this.searchQuery.next(this.inputValue.trim());
      this.isLoading = true;
    } else {
      this.races = [];
      this.showEmptyState = false;
      this.isLoading = false;
    }
  }

  public openEventDetails(race: Race): void {
    if (race) {
      this.raceService.setCurrentRace(race);
      this.router.navigate([RACE_DETAILS], {
        relativeTo: this.route, queryParams: {eventId: race.eventId, raceId: race.id},
        queryParamsHandling: "merge"
      });
    }
  }
}
